// eslint-disable-next-line react/jsx-curly-newline
import React from "react";

const FAQFrench = (props) => (
  <div>
    <h3>Quelle est la cotisation annuelle de AuctionACCESS?</h3>
    <p className="faq">
      La cotisation annuelle est de {props.amount} $ par personne dans AuctionACCESS.
      L'adhésion facilite l'accréditation auprès de plus de 320 marchés aux
      enchères aux États-Unis et au Canada.
    </p>
    <h3>Comment puis-je payer mon adhésion?</h3>
    <p className="faq">
      L'adhésion peut être payée par carte de crédit, carte de débit, ou ACH en
      entrant vos informations à droite. Vous pouvez également vous connecter à
      votre compte à AuctionACCESS.com pour renouveler plusieurs adhésions si
      vous êtes propriétaire ou dirigeant.
    </p>
    <p className="faq">
      Pour plus d'informations sur l'adhésion, s'il vous plaît visitez notre page
      <a href="https://www.auctionaccess.com/faq/"> FAQ</a>
    </p>
  </div>
);

export default FAQFrench;
